import { motion } from "framer-motion";
import { ArrowRight, ArrowUpRight } from "@phosphor-icons/react";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Hero() {
  return (
    <section id="top" data-testid="hero-section" className="relative pt-32 md:pt-40 pb-20 md:pb-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-5xl"
        >
          <div className="overline mb-6" data-testid="hero-overline">
            Est. 2017 · Chartered Accountants · India
          </div>
          <h1
            data-testid="hero-heading"
            className="font-serif-display text-[44px] sm:text-6xl lg:text-[88px] leading-[0.95] tracking-tight text-[#1B3B2B]"
          >
            Anand Aditya <span className="text-[#D4AF37]">&amp;</span> Co. <br className="hidden sm:block" />
            <em className="text-[#D4AF37] not-italic font-serif-display italic">
              Chartered Accountants
            </em>
          </h1>
          <p className="mt-8 max-w-2xl text-[#4A5D53] text-base sm:text-lg leading-relaxed">
            A chartered accountancy practice — members of the Institute of Chartered Accountants
            of India. Areas of practice include taxation, audit, regulatory compliance and
            financial advisory.
          </p>

          <blockquote className="mt-10 max-w-3xl pl-6 border-l-2 border-[#D4AF37] font-serif-display text-xl sm:text-2xl text-[#1B3B2B] leading-relaxed italic">
            We recognise every client is unique. We take time to understand their goals and
            collaborate closely to craft tailored solutions — covering everything from A to Z and
            delivering comprehensive, customised services that help clients achieve measurable
            results.
          </blockquote>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("contact")}
              className="btn-primary"
            >
              Schedule a consultation
              <ArrowRight size={16} weight="bold" />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("services")}
              className="btn-secondary"
            >
              Our services
              <ArrowUpRight size={16} weight="bold" />
            </button>
          </div>

          <div className="mt-16 grid grid-cols-3 max-w-2xl gap-8">
            {[
              { k: "8+", v: "Years in practice" },
              { k: "70+", v: "Clients across the globe" },
              { k: "20+", v: "Industries overseen" },
            ].map((s, i) => (
              <div key={i} data-testid={`hero-stat-${i}`}>
                <div className="font-serif-display text-3xl sm:text-4xl text-[#1B3B2B]">{s.k}</div>
                <div className="overline mt-2 text-[10px] text-[#4A5D53]">{s.v}</div>
              </div>
            ))}
          </div>

          <div className="mt-14 pt-6 border-t border-[#D1CEC5] max-w-xl">
            <div className="overline">
              Trusted across India · Mauritius · USA · UAE · Singapore
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
